import {
  Anchor,
  Button,
  Center,
  Group,
  Image,
  Loader,
  Text,
  Title,
} from "@mantine/core";
import { checkToken, useAuth } from "../auth/AuthContext";
import { IconUser, IconUserPlus } from "@tabler/icons";
import { ReactComponent as Logo } from "../assets/svg/OI_logo.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ConfigProvider, useConfig } from "../hooks/useConfig";
import { useEffect, useState } from "react";
import { AXIOS_INSTANCE } from "../api/axios-instance";

const WelcomePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const config = useConfig();
  const auth = useAuth();
  const [hasNetworkError, setHasNetworkError] = useState(false);
  

  // useEffect(() => {
  //   const interceptorId = AXIOS_INSTANCE.interceptors.response.use(
  //     (response) => response,
  //     (error) => {
  //       if (error.code === "ERR_NETWORK") {
  //         setHasNetworkError(true);
  //         navigate("/", { replace: true });
  //       }
  //       return Promise.reject(error);
  //     }
  //   );
  //
  //   return () => {
  //     AXIOS_INSTANCE.interceptors.response.eject(interceptorId);
  //   };
  // }, []);

  useEffect(() => {
    const isAuthenticated =
        // !!auth.isAuthenticated &&
        checkToken(auth.access_token!) &&
        !!auth.access_token &&
        auth.access_token !== "null" &&
        auth.access_token !== "" 
        // auth.user;
    console.log("Welcome page: ",auth, isAuthenticated, hasNetworkError);
    if (!hasNetworkError && isAuthenticated) {
      navigate("/calls");
    }
  }, [auth, navigate, hasNetworkError]);

  // if (auth.isLoading || isAuthenticated) {
  //   return (
  //     <Center style={{ marginTop: "25%" }}>
  //       <Loader />
  //     </Center>
  //   );
  // }

  return (
    <div
      style={{
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        // width: "90vw",
      }}
    >
      <div style={{ padding: 16 }}>
        {config.logoBase64 ? (
          <Image src={config.logoBase64} width={200} />
        ) : (
          <Logo width={300} />
        )}
        <Title order={1} mt={60}>
          {config.name ?? t("pages.welcome-starimpact")}
        </Title>
        <Text size="xl" mt={10}>
          {config.message ?? t("pages.create-account-register-organization")}
        </Text>
        <Group my={50} align="center">
          <Anchor
            href={`https://${process.env.REACT_APP_FUSIONAUTH_HOST}/oauth2/authorize?client_id=${process.env.REACT_APP_FUSIONAUTH_CLIENT_ID}&response_type=code&redirect_uri=${process.env.REACT_APP_FUSIONAUTH_REDIRECT_URI}&scope=offline_access&locale=${config.defaultLanguage}`}
          >
            <Button
              variant="light"
              radius="xl"
              leftIcon={<IconUser size={14} />}
            >
              {t("pages.login")}
            </Button>
          </Anchor>
          <Anchor
            href={`https://${process.env.REACT_APP_FUSIONAUTH_HOST}/oauth2/register?client_id=${process.env.REACT_APP_FUSIONAUTH_CLIENT_ID}&response_type=code&redirect_uri=${process.env.REACT_APP_FUSIONAUTH_REDIRECT_URI}&locale=${config.defaultLanguage}`}
          >
            <Button
              variant="filled"
              radius="xl"
              leftIcon={<IconUserPlus size={14} />}
            >
              {t("pages.register")}
            </Button>
          </Anchor>
        </Group>
        {config.landingHtml && (
          <div style={{ marginTop: 24 }} dangerouslySetInnerHTML={{ __html: config.landingHtml }} />
        )}
      </div>
    </div>
  );
};

export default () => (
  <ConfigProvider>
    <WelcomePage />
  </ConfigProvider>
);
